import React from 'react';
import '../../components/datagridNoResponsive/DatagridNoResponsive.scss';

interface Props {
  children: any;
  datagridWidth: number;
  className?: string;
  noTopPadding?: boolean;
}

export const DatagridNoResponsive = ({
  children,
  datagridWidth,
  className,
  noTopPadding,
}: Props) => {
  return (
    <div
      className={`datagrid-no-responsive ${className}${noTopPadding ? ' no-top-padding' : ''}`}
      style={{ width: datagridWidth }}
    >
      {children}
    </div>
  );
};
